import type { StatsReportsIdsEnum } from '@empathybroker/tsclient-stats/dist/enums/stats-reports-ids.enum'
import type { RelatedEventData } from '@empathybroker/tsclient-stats/dist/models/related-event/related-event-data'
import type { RelatedData } from '@empathybroker/tsclient-stats/dist/models/related/related-data'
import type { Ref } from 'vue'
import type Vue from 'vue'
import { getCurrentInstance, ref } from 'vue'
import { ANALYTICS_CONSTS } from '../../store/analytics/analytics.consts'
import { mapActions } from '../utils'

interface UseStatsReport {
  isLoading: Ref<boolean>
  errorMessage: Ref<string | null>
  data: Ref<RelatedData['data'][number] | RelatedEventData['data'][number] | null>
}

export function useStatsReport({
  statsReportId,
  query,
  productId,
}: {
  statsReportId: StatsReportsIdsEnum
  query: string
  productId: string
}): UseStatsReport {
  const {
    proxy: { $store },
  } = getCurrentInstance() as { proxy: Vue }

  const isLoading = ref(false)
  const errorMessage = ref<string | null>(null)

  const data = ref<RelatedData['data'][number] | RelatedEventData['data'][number] | null>(null)

  const { fetchStatsReport } = mapActions($store, ANALYTICS_CONSTS.moduleName, {
    fetchStatsReport: ANALYTICS_CONSTS.actions.fetchStatsReport,
  })

  const fetchRelatedData = async (): Promise<void> => {
    isLoading.value = true
    try {
      const relatedReportResponse = await fetchStatsReport({
        id: statsReportId,
        params: {
          query,
          productId,
        },
      })

      data.value = relatedReportResponse.data.data[0]
    } catch (error) {
      if (error instanceof Error) {
        errorMessage.value = error.message
      }
    } finally {
      isLoading.value = false
    }
  }

  fetchRelatedData()

  return {
    isLoading,
    errorMessage,
    data,
  }
}
